/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Quirk del legacy: variables_set_value declara `int Cantidad = <valor>;` con clave
// block.id en definitions_, así cada instancia del bloque agrega su propia declaración.

export const variables_set_value = (block, generator) => {
  const number = generator.valueToCode(block, 'NUM', generator.ORDER_NONE);
  generator.definitions_[`variables_set_value_${block.id}`] = `int Cantidad = ${number};`;
  return '';
};

export const variables_get_value = (block, generator) => {
  return ['Cantidad', generator.ORDER_ATOMIC];
};

export const variables_add_one = () => {
  return '\nCantidad = Cantidad + 1;\ndelay(1000);';
};

export const variables_substract_one = () => {
  return '\nCantidad = Cantidad - 1;\ndelay(1000);';
};
